import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';

import { GlobalService } from '../../services/global.service';
import { SnackBarService } from './snackbar.service';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.css']
})

export class SnackBarComponent implements OnInit {
    public message: string = "";
    public type: number;
    public visible: boolean = false;
    public duration: number = 3000;
    public clickable: number = 0;

    @ViewChild('snackbar') snackbar: ElementRef;

    constructor(private snackBarService: SnackBarService, private renderer: Renderer2) {
        snackBarService.snackBar$.subscribe(snackbar => {
            this.message = snackbar.message;
            this.type = snackbar.type;
            this.clickable = snackbar.clickable;
            this.duration = snackbar.duration;
            this.showSnackBar();
        })
    }

    showSnackBar(): void {
        this.renderer.setStyle(this.snackbar.nativeElement, 'display', 'flex');
        this.renderer.setStyle(this.snackbar.nativeElement, 'animation', 'animateIn');
        this.renderer.setStyle(this.snackbar.nativeElement, 'animation-duration', (this.duration / 1000).toString() + 's');
        this.renderer.setStyle(this.snackbar.nativeElement, 'animation-fill-mode', 'forwards');
        this.renderer.setStyle(this.snackbar.nativeElement, 'animation-timing-function', 'linear');
        this.renderer.setStyle(this.snackbar.nativeElement, 'pointer-events', 'auto');

        // this.visible = true;

        setTimeout(() => {
            // console.log(this.duration);
            this.renderer.setStyle(this.snackbar.nativeElement, 'display', 'none');
            this.renderer.setStyle(this.snackbar.nativeElement, 'animation', '');
            this.renderer.setStyle(this.snackbar.nativeElement, 'animation-duration', '');
            this.renderer.setStyle(this.snackbar.nativeElement, 'animation-fill-mode', '');
            this.renderer.setStyle(this.snackbar.nativeElement, 'animation-timing-function', '');
            this.renderer.setStyle(this.snackbar.nativeElement, 'pointer-events', 'none');
        }, this.duration);
    }

    ngOnInit(): void {

    }
}

